import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import AuthService from "../../service/AuthService";
import { useState } from "react";
import CustomPopup from "../../common/components/popup/CustomPopup";
import { Theme } from "../../common/Theme";

function LockLoginMessagePage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const service = new AuthService();

    // api 에러 팝업
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    // resend success popup
    const [isResendSuccessPopupOpened, setIsResendSuccessPopupOpened] = useState(false);

    const handleResendUnlockMail = async () => {
        try {
            await service.resendUnlockLoginMail({ userId: userId });
            setIsResendSuccessPopupOpened(true);
        } catch (error) {
            setPopupMessage(error.message);
            setIsPopupOpened(true);
        }
    };

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    Laundry Crew Admin
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>Laundry Crew account created</C2Text>
                <SizedBox height={"44px"} />
                <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                    A verification email has been sent to your email address. For security purposes, please verify your
                    account using the verification email sent to [{userId}].
                    <br />
                    <br />
                    Click the 'Resend email' button if you are unable to locate the verification email or wish to
                    receive another email.
                    <br />
                    <br />
                    If the failed sign in attempts were not you, then please verify your account and reset your
                    password.
                    <br />
                    <br />
                    * Please check the spam folder of your email if you do not see the verification email in your inbox.
                    If you have trouble receiving an email, please use other email and try joining again.
                    <br />
                    <br />
                </C2Text>
                <SizedBox height={"32px"} />
                <FullWidthButton onClick={() => navigate("/auth/login")} text={"Ok"} />
                <SizedBox height={"12px"} />
                <FullWidthButton
                    backgroundColor={Theme.color.white}
                    onClick={handleResendUnlockMail}
                    text={"Resend Email"}
                />
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                    <C3Text fontColor={Theme.color.gray500}>Copyright © LG Electronics. All Rights Reserved.</C3Text>
                </Row>
            </Column>
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
            <CustomPopup
                isOpen={isResendSuccessPopupOpened}
                onConfirm={() => navigate("/auth/login")}
                message={"Confirmation email re-sent."}
            />
        </AuthContentWrapper>
    );
}

export default LockLoginMessagePage;
